import Toastify from "toastify-js";
import "../../../css/bem/_toast.scss";

export type IToastifyOptions = {
	duration?: number;
	backgroundColor?: string;
	gravity?: "bottom" | "top";
	className?: string;
};

const DEFAULTS: IToastifyOptions = {
	duration: 3000,
	backgroundColor: "#000",
	gravity: "bottom",
	className: "toastify-center rounded swatch-danger px-lg-5",
};

export const displayToast = (message, options: IToastifyOptions = {}) => {
	// had to import it like this to get around jest tests failing
	import("toastify-js/src/toastify.css").then(() => {
		const toastOptions = {
			...DEFAULTS,
			...options,
		};
		// prevents multiple toasts
		const toast = document.querySelector(".toastify");

		if (toast) {
			toast.classList.add("d-none");
		}

		Toastify({
			text: message,
			...toastOptions,
		}).showToast();
	});
};
